exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-header-template=\"3\"] section.page-title{grid-area:header-start/header-start/pagetitle-end/pagetitle-end;padding:calc(var(--hd-height) + 2rem) 0 2rem;margin:0;max-width:100%}body[data-header-template=\"3\"] #vue-header{position:sticky;top:0}", ""]);

// exports
